import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { spacingClassNamePropType } from '../../__utils/spacingClassNamePropType';

const ItemTitle = ({ children, level, isCaps, hideOverflow, className, qaId }) => {
  const itemTitleClasses = classNames({
    'uni-item-title': level === 'default',
    'uni-item-title--small': level === 'small',
    'uni-item-title--caps': isCaps,
    'u-text-overflow': hideOverflow,
    [className]: className,
  });

  return (
    <h5 className={itemTitleClasses} data-qa-id={qaId}>
      {children}
    </h5>
  );
};

ItemTitle.propTypes = {
  children: PropTypes.string,
  level: PropTypes.oneOf(['default', 'small']),
  isCaps: PropTypes.bool,
  hideOverflow: PropTypes.bool,
  className: spacingClassNamePropType,
  qaId: PropTypes.string,
};

ItemTitle.defaultProps = {
  level: 'default',
  className: '',
};

export default ItemTitle;



// WEBPACK FOOTER //
// ./src/type/item-title/index.jsx